export const preventDefault = (func=_.noop) => (e) => {
  e.preventDefault();
  return func(e);
}

export const stopPropagation = (func=_.noop) => (e) => {
  e.stopPropagation();
  return func(e);
}

export const stopEverything = (func=_.noop) => (e) => {
  e.preventDefault();
  e.stopPropagation();
  return func(e);
}

export const gV = (fn, ...args) => (event) => {
  const {detail, target} = event;
  const val = detail?.checked ?? detail?.value ?? target.checked ?? target.value;
  return fn(...args, val, event);
}